export const services = Object.freeze({
  NODE_ENDPOINT_GET_ENVCONF: "sys/getenvconf",
  NODE_ENDPOINT_SET_ENVCONF: "sys/setenvconf",
})
